import React, {useState} from 'react'
import {RIF} from '../../lib'
import {selectTheme} from '../../store'

export enum QuestionnaireInputSize {
  extraSmall = '72px',
  verySmall = '340px',
  small = '36.286rem',
  medium = '38.143rem',
  big = '53.143rem',
  displayLogic = '120px',
  displayLogicBetween = '88px',
}

export enum QuestionnaireInputHeight {
  medium = '40px',
  big = '48px',
}

export const QuestionnaireInput = (props: {
  defaultValue?: string
  initialValue?: string
  onChangeAction?: (arg: string) => void
  placeholder: string
  maxLength: number
  size?: QuestionnaireInputSize
  disabled?: boolean
  inputType?: 'number' | 'integer' | 'text'
  hideWordCount?: boolean
  questionnaireInputHeight?: QuestionnaireInputHeight
}) => {
  const {color, fontWeight, fontSize} = selectTheme()
  const {
    defaultValue,
    initialValue,
    placeholder,
    onChangeAction,
    maxLength,
    size,
    disabled,
    inputType,
    hideWordCount,
    questionnaireInputHeight,
  } = props
  const [focusing, setFocusing] = useState(false)
  const [inputValue, setInputValue] = useState(defaultValue ?? '')

  const fontSizeMap = {
    [QuestionnaireInputHeight.medium]: fontSize.h6,
    [QuestionnaireInputHeight.big]: fontSize.h3,
  }

  const handleFocus = () => {
    setFocusing(true)
    if (inputValue === initialValue) {
      setInputValue('')
    }
  }

  const handleBlur = () => {
    setFocusing(false)
    if (inputValue === '') {
      setInputValue(initialValue ?? '')
      if (onChangeAction) onChangeAction(initialValue ?? '')
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (e.target.value === '' || e.target.value === '-') {
      setInputValue(e.target.value)
    } else {
      if (inputType === 'number') {
        if (e.target.value === '') {
          setInputValue('0')
        } else {
          setInputValue(
            e.target.value
              .replace(/[^0-9.-]/g, '')
              .replace(/(?!^)-/g, '')
              .replace(/(\..*)\./g, '$1'),
          )
        }
      } else if (inputType === 'integer') {
        if (e.target.value === '') {
          setInputValue('0')
        } else {
          setInputValue(e.target.value.replace(/[^0-9-]/g, '').replace(/(?!^)-/g, ''))
        }
      } else {
        setInputValue(e.target.value)
      }
      if (onChangeAction) onChangeAction(e.target.value)
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      if (onChangeAction) onChangeAction(inputValue)
    }
  }

  return (
    <div
      // {...props}
      css={{
        width: size ?? '100%',
        height: questionnaireInputHeight ?? QuestionnaireInputHeight.medium,
        minHeight: questionnaireInputHeight ?? QuestionnaireInputHeight.medium,
        position: 'relative',
        borderRadius: '5px',
        overflow: 'hidden',
        border: `1px solid ${disabled ? color.border.default : focusing ? color.grey_400 : color.border.default}`,
        ':hover': {
          border: `1px solid ${disabled ? color.border.default : color.grey_400}`,
        },
      }}>
      <textarea
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        value={inputValue}
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={disabled}
        // rows={1}
        css={{
          border: 'none',
          width: '100%',
          lineHeight: '18px',
          height: '100%',
          margin: 0,
          padding: `11px ${hideWordCount ? '0' : '110px'} 0 20px`,
          backgroundColor: disabled ? color.surface.default : color.white,
          color: disabled ? color.state.disabled : color.textIcon.title,
          paddingLeft: '16px',
          fontSize: fontSizeMap[questionnaireInputHeight ?? QuestionnaireInputHeight.medium],
          resize: 'none',
          boxSizing: 'border-box',
          overflowY: 'auto',
          // minHeight: '100%',
          // backgroundColor: color.white,
          ':focus': {
            outline: 'none',
          },
        }}
      />
      {RIF(
        focusing && !hideWordCount,
        <p
          css={{
            color: color.grey_400,
            fontWeight: fontWeight.medium,
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            position: 'absolute',
            right: '20px',
            top: '0',
          }}>
          {inputValue.length} / {maxLength}
        </p>,
      )}
    </div>
  )
}
